/* eslint-disable @typescript-eslint/camelcase */
import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import {
  ConvertObjectCamelToSnakeCase,
  NGEN_BOOKING
} from "@/app/infrastructures/misc/Utils";
import {
  getConfigDimensionDivider,
  getConfigIsminimumVolumePerPiece,
  getConfigMinimumVolumePerPiece
} from "@/app/ui/views/cargo/modules/cargo-module";
import {
  EditCargoRequestInteface,
  AppendBagOrSttNumberInterface,
  AddCargoRequestInteface,
  UpdateRetryCargoRequestInterface,
  AwbValidationRequestInterface
} from "@/data/payload/contracts/CargoRequest";
import { DimensionData, SearchFlight } from "@/domain/entities/Cargo";
import {
  QueryParamsEntities,
  QueryParamsEntitiesV3
} from "@/domain/entities/MainApp";
import { flags } from "@/feature-flags";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";

export class EditCargoApiRequest implements EditCargoRequestInteface {
  cargoNo: string;
  actualTotalGrossWeight: number;
  actualTotalVolumeWeight: number;
  cargoActualPiece: number;
  bagOrStt: EditCargoBagOrStt[];
  actualDimension: DimensionData;
  partnerId?: number;
  dimensions: DimensionPieces[];
  photoProof: string[];
  cargoTotalEstimateGrossWeight?: number;
  cargoTotalEstimateVolumeWeight?: number;
  cargoTotalChargeableWeight?: number;
  cargoTotalCustomChargeableWeight?: number;
  cargoTotalEstimateChargeableWeight?: number;
  isNewCalculation?: boolean;
  cargoType?: string;
  calculateType?: string;
  isValidAwbManual?: boolean;
  isCargoDimensionOn?: boolean;
  cargoTypeStatus?: string;
  currentChargeableWeight?: number;
  cargoId: number;
  constructor(
    cargoNo: string,
    actualTotalGrossWeight: number,
    actualTotalVolumeWeight: number,
    cargoActualPiece: number,
    bagOrStt: EditCargoBagOrStt[],
    actualDimension: DimensionData,
    partnerId?: number,
    dimensions?: DimensionPieces[],
    photoProof?: string[],
    cargoTotalEstimateGrossWeight?: number,
    cargoTotalEstimateVolumeWeight?: number,
    cargoTotalChargeableWeight?: number,
    cargoTotalCustomChargeableWeight?: number,
    cargoTotalEstimateChargeableWeight?: number,
    isNewCalculation?: boolean,
    cargoType?: string,
    calculateType?: string,
    isValidAwbManual?: boolean,
    isCargoDimensionOn?: boolean,
    cargoTypeStatus?: string,
    currentChargeableWeight?: number,
    cargoId?: number
  ) {
    this.cargoId = cargoId || 0;
    this.cargoNo = cargoNo;
    this.actualTotalGrossWeight = actualTotalGrossWeight;
    this.actualTotalVolumeWeight = actualTotalVolumeWeight;
    this.cargoActualPiece = cargoActualPiece;
    this.bagOrStt = bagOrStt;
    this.partnerId = partnerId;
    this.actualDimension = actualDimension;
    this.dimensions = dimensions || [];
    this.photoProof = photoProof || [];
    this.cargoTotalEstimateGrossWeight = cargoTotalEstimateGrossWeight;
    this.cargoTotalEstimateVolumeWeight = cargoTotalEstimateVolumeWeight;
    this.cargoTotalChargeableWeight = cargoTotalChargeableWeight;
    this.cargoTotalCustomChargeableWeight = cargoTotalCustomChargeableWeight;
    this.cargoTotalEstimateChargeableWeight = cargoTotalEstimateChargeableWeight;
    this.isNewCalculation = isNewCalculation;
    this.cargoType = cargoType;
    this.calculateType = calculateType;
    this.isValidAwbManual = isValidAwbManual;
    this.isCargoDimensionOn = isCargoDimensionOn;
    this.cargoTypeStatus = cargoTypeStatus;
    this.currentChargeableWeight = currentChargeableWeight;
  }

  get dimensionDivider() {
    return getConfigDimensionDivider(this.cargoType);
  }

  get configIsMinimumVolumePerPiece(): boolean {
    const flag = FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();

    if (this.cargoType === "plane" && this.cargoTypeStatus === "auto")
      return !!flag;
    return false;
  }

  get configMinimumVOlumePerPiece() {
    const flag = FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();

    if (this.cargoType === "plane" && this.cargoTypeStatus === "auto")
      return flag;
    return 0;
  }

  toJSON(): string {
    return JSON.stringify({
      cargo_id: this.cargoId,
      cargo_no: this.cargoNo,
      actual_total_gross_weight: this.actualTotalGrossWeight,
      actual_total_volume_weight: this.actualTotalVolumeWeight,
      actual_dimension: {
        cargo_actual_length_dimension: this.actualDimension?.length || 0,
        cargo_actual_width_dimension: this.actualDimension?.width || 0,
        cargo_actual_height_dimension: this.actualDimension?.height || 0
      },
      cargo_actual_piece: this.cargoActualPiece,
      bag_or_stt: this.bagOrStt,
      partner_id: this.partnerId,
      hub_id: getHubData()?.hubId || 0,
      hub_name: getHubData()?.hubName || "",
      hub_origin_city: getHubData()?.originCity || "",
      hub_district_code: getHubData()?.hubDistrictCode || "",
      dimensions: this.dimensions,
      photo_proof: this.photoProof,
      cargo_total_estimate_gross_weight: this.cargoTotalEstimateGrossWeight,
      cargo_total_estimate_volume_weight: this.cargoTotalEstimateVolumeWeight,
      cargo_total_chargeable_weight: this.cargoTotalChargeableWeight,
      cargo_total_custom_chargeable_weight: this
        .cargoTotalCustomChargeableWeight,
      cargo_total_estimate_chargeable_weight: this
        .cargoTotalEstimateChargeableWeight,
      is_use_new_calculation: this.isNewCalculation,
      cargo_dimension_divider: this.dimensionDivider,
      calculate_type: this.calculateType,
      is_minimum_volume_per_piece: this.configIsMinimumVolumePerPiece,
      is_valid_awb_manual: this.isValidAwbManual,
      is_cargo_dimension_on: this.isCargoDimensionOn,
      min_volume_per_piece: FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue(),
      current_chargeable_weight: this.currentChargeableWeight
    });
  }
}

export class EditCargoBagOrStt {
  bag_no: string;
  stt_no: string;
  action: string;
  is_scan_by_bag: boolean;
  constructor(
    bagNo: string,
    sttNo: string,
    action: string,
    is_scan_by_bag: boolean
  ) {
    this.bag_no = bagNo;
    this.stt_no = sttNo;
    this.action = action;
    this.is_scan_by_bag = is_scan_by_bag;
  }
}

export class AddBagOrSttNumberRequest implements AppendBagOrSttNumberInterface {
  private bagOrSttNo: BagOrSttNumber;
  private cargoProductType: string;
  private cargoCommodity: string;
  private cargoType: string;
  private partnerId?: number;

  constructor(
    bagOrSttNo: BagOrSttNumber,
    cargoProductType: string,
    cargoCommodity: string,
    cargoType: string,
    partnerId?: number
  ) {
    this.bagOrSttNo = bagOrSttNo;
    this.cargoProductType = cargoProductType;
    this.cargoCommodity = cargoCommodity;
    this.cargoType = cargoType;
    this.partnerId = partnerId;
  }

  toJSON(): string {
    return JSON.stringify({
      bag_or_stt: this.bagOrSttNo,
      cargo_product_type: this.cargoProductType,
      cargo_commodity: this.cargoCommodity,
      cargo_type: this.cargoType,
      partner_id: this.partnerId,
      hub_id: getHubData()?.hubId || 0
    });
  }
}

export class BagOrSttNumber {
  bag_no: string;
  stt_no: string;

  constructor(bagNo: string, sttNumber: string) {
    this.bag_no = bagNo;
    this.stt_no = sttNumber;
  }
}

export class AddCargoRequest implements AddCargoRequestInteface {
  origin_airport_code: string;
  destination_airport_code: string;
  est_total_cargo_grossweigth: number;
  est_total_cargo_volumeweight: number;
  partner_name: string;
  partner_type: string;
  cargo_no: string;
  cargo_vehicle_no: string;
  actual_total_cargo_grossweigth: number;
  actual_total_cargo_volumeweight: number;
  route: string;
  total_stt: number;
  total_piece: number;
  cargo_commodity: string;
  product_cargo: string;
  cargo_type: string;
  origin_city_code: string;
  destination_city_code: string;
  departure_date: string;
  arrival_date: string;
  bag_or_stt: AddBagOrStt[];
  is_cargo_plane_manual: boolean | null;
  cargo_over_cutoff_limit: boolean | null;
  cargo_rtc_turn_auto: boolean | null;
  dimensions: DimensionPieces[];
  cargo_actual_piece: number;
  ngen_booking = {
    product_name: NGEN_BOOKING.PRODUCT_NAME,
    e_cargo_unique_id: NGEN_BOOKING.E_CARGO_UNIQUE_ID,
    awb_no: NGEN_BOOKING.AWB_NO,
    awb_prefix: NGEN_BOOKING.AWB_PREFIX,
    shc: "" as any,
    flight_plan_for_e_cargo: [] as FlightPlanForECargo[]
  };
  is_from_rtc: boolean;
  rtc_id: number;
  est_dimension?: DimensionData;
  actual_dimension?: DimensionData;
  nog?: string;
  rebookingId?: number;
  ngen_created_at?: string;
  hub_id?: number;
  hub_name?: number;
  hub_origin_city?: string;
  hub_district_code?: string;
  shc?: string;
  is_use_sabre?: boolean;
  sequential_flight?: number;
  total_flight?: number;
  photo_proof?: Array<string>;
  cargoTotalChargeableWeight?: number;
  cargoTotalCustomChargeableWeight?: number;
  cargoTotalEstimateChargeableWeight?: number;
  isNewCalculation?: boolean;
  calculateType?: string;
  isValidAwbManual?: boolean;
  isCargoDimensionOn?: boolean;
  currentChargeableWeight?: number;

  constructor(
    origin_airport_code: string,
    destination_airport_code: string,
    est_total_cargo_grossweigth: number,
    est_total_cargo_volumeweight: number,
    partner_name: string,
    partner_type: string,
    cargo_no: string,
    cargo_vehicle_no: string,
    actual_total_cargo_grossweigth: number,
    actual_total_cargo_volumeweight: number,
    route: string,
    total_stt: number,
    total_piece: number,
    cargo_commodity: string,
    product_cargo: string,
    cargo_type: string,
    origin_city_code: string,
    destination_city_code: string,
    departure_date: string,
    arrival_date: string,
    bag_or_stt: AddBagOrStt[],
    is_cargo_plane_manual: boolean | null,
    cargo_over_cutoff_limit: boolean | null,
    cargo_rtc_turn_auto: boolean | null,
    cargo_actual_piece: number,
    is_from_rtc: boolean,
    rtc_id: number,
    flight_plan_for_e_cargo?: FlightPlanForECargo[],
    dimensions?: DimensionPieces[],
    est_dimension?: DimensionData,
    actual_dimension?: DimensionData,
    nog?: string,
    rebookingId?: number,
    ngen_created_at?: string,
    shc?: string,
    is_use_sabre?: boolean,
    sequential_flight?: number,
    total_flight?: number,
    photo_proof?: Array<string>,
    cargoTotalChargeableWeight?: number,
    cargoTotalCustomChargeableWeight?: number,
    cargoTotalEstimateChargeableWeight?: number,
    isNewCalculation?: boolean,
    calculateType?: string,
    isValidAwbManual?: boolean,
    isCargoDimensionOn?: boolean,
    currentChargeableWeight?: number
  ) {
    this.origin_airport_code = origin_airport_code;
    this.destination_airport_code = destination_airport_code;
    this.est_total_cargo_grossweigth = est_total_cargo_grossweigth;
    this.est_total_cargo_volumeweight = est_total_cargo_volumeweight;
    this.partner_name = partner_name;
    this.partner_type = partner_type;
    this.cargo_no = cargo_no;
    this.cargo_vehicle_no = cargo_vehicle_no;
    this.actual_total_cargo_grossweigth = actual_total_cargo_grossweigth;
    this.actual_total_cargo_volumeweight = actual_total_cargo_volumeweight;
    this.route = route;
    this.total_stt = total_stt;
    this.total_piece = total_piece;
    this.cargo_commodity = cargo_commodity;
    this.product_cargo = product_cargo;
    this.cargo_type = cargo_type;
    this.origin_city_code = origin_city_code;
    this.destination_city_code = destination_city_code;
    this.departure_date = departure_date;
    this.arrival_date = arrival_date;
    this.bag_or_stt = bag_or_stt;
    this.is_cargo_plane_manual = is_cargo_plane_manual;
    this.cargo_over_cutoff_limit = cargo_over_cutoff_limit || false;
    this.cargo_rtc_turn_auto = cargo_rtc_turn_auto;
    this.ngen_booking.product_name = product_cargo;
    this.ngen_booking.flight_plan_for_e_cargo = flight_plan_for_e_cargo || [];
    this.ngen_booking.shc = shc;
    this.dimensions = dimensions || [];
    this.is_from_rtc = is_from_rtc;
    this.rtc_id = rtc_id;
    this.est_dimension = est_dimension;
    this.actual_dimension = actual_dimension;
    this.nog = nog;
    this.rebookingId = rebookingId;
    this.cargo_actual_piece = cargo_actual_piece;
    this.ngen_created_at = ngen_created_at;
    // this.hub_id = getHubData()?.hubId || 0;
    // this.hub_name = getHubData()?.hubName || "";
    // this.hub_origin_city = getHubData()?.originCity || "";
    // this.hub_district_code = getHubData()?.hubDistrictCode || "";
    this.is_use_sabre = is_use_sabre;
    this.sequential_flight = sequential_flight;
    this.total_flight = total_flight;
    this.photo_proof = photo_proof;
    this.cargoTotalChargeableWeight = cargoTotalChargeableWeight;
    this.cargoTotalCustomChargeableWeight = cargoTotalCustomChargeableWeight;
    this.cargoTotalEstimateChargeableWeight = cargoTotalEstimateChargeableWeight;
    this.isNewCalculation = isNewCalculation;
    this.calculateType = calculateType;
    this.isValidAwbManual = isValidAwbManual;
    this.isCargoDimensionOn = isCargoDimensionOn;
    this.currentChargeableWeight = currentChargeableWeight;
  }

  get hubId() {
    return getHubData()?.hubId || 0;
  }

  get hubName() {
    return getHubData()?.hubName || "";
  }

  get hubOriginCity() {
    return getHubData()?.originCity || "";
  }

  get hubDistrictCode() {
    return getHubData()?.hubDistrictCode || "";
  }

  get isUseSabre() {
    return (
      FlagsPermissionCargo.feature_flight_v2_enable.isEnabled() &&
      this.cargo_type === "plane" &&
      !this.is_cargo_plane_manual
    );
  }

  get isFromRTCSabre() {
    return this.is_from_rtc && this.isUseSabre;
  }

  get payloadPart1() {
    return {
      origin_airport_code: this.origin_airport_code,
      destination_airport_code: this.destination_airport_code,
      est_total_cargo_grossweigth: this.est_total_cargo_grossweigth,
      est_total_cargo_volumeweight: this.est_total_cargo_volumeweight,
      partner_name: this.partner_name,
      partner_type: this.partner_type,
      cargo_no: this.cargo_no,
      cargo_vehicle_no: this.cargo_vehicle_no,
      actual_total_cargo_grossweigth: this.actual_total_cargo_grossweigth,
      actual_total_cargo_volumeweight: this.actual_total_cargo_volumeweight,
      route: this.route,
      total_stt: this.total_stt,
      total_piece: this.total_piece,
      cargo_commodity: this.cargo_commodity,
      product_cargo: this.product_cargo
    };
  }

  get dimensionDivider() {
    return getConfigDimensionDivider(this.cargo_type);
  }

  get configIsMinimumVolumePerPiece(): boolean {
    const flag = FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();

    if (this.cargo_type === "plane" && !this.is_cargo_plane_manual)
      return !!flag;
    return false;
  }

  get configMinimumVOlumePerPiece() {
    const flag = FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();

    if (this.cargo_type === "plane" && !this.is_cargo_plane_manual) return flag;
    return 0;
  }

  toJSON(): string {
    let data: any = {
      ...this.payloadPart1,
      cargo_type: this.cargo_type,
      origin_city_code: this.origin_city_code,
      destination_city_code: this.destination_city_code,
      departure_date: this.departure_date,
      arrival_date: this.arrival_date,
      bag_or_stt: this.bag_or_stt,
      estimation_dimension: {
        cargo_est_length_dimension: this.est_dimension?.length,
        cargo_est_width_dimension: this.est_dimension?.width,
        cargo_est_height_dimension: this.est_dimension?.height
      },
      actual_dimension: {
        cargo_actual_length_dimension: this.actual_dimension?.length || 0,
        cargo_actual_width_dimension: this.actual_dimension?.width || 0,
        cargo_actual_height_dimension: this.actual_dimension?.height || 0
      },
      nog: this.nog,
      rebooking_id: this.rebookingId,
      cargo_actual_piece: this.cargo_actual_piece,
      ngen_created_at: this.ngen_created_at,
      hub_id: this.hubId,
      hub_name: this.hubName,
      hub_origin_city: this.hubOriginCity,
      hub_district_code: this.hubDistrictCode,
      is_from_rtc: this.is_from_rtc,
      rtc_id: this.rtc_id,
      cargo_over_cutoff_limit: this.cargo_over_cutoff_limit,
      cargo_rtc_turn_auto: this.cargo_rtc_turn_auto,
      is_from_rtc_sabre: this.isFromRTCSabre,
      is_use_sabre: this.isUseSabre,
      photo_proof: this.photo_proof,
      cargo_total_chargeable_weight: this.cargoTotalChargeableWeight,
      cargo_total_custom_chargeable_weight: this
        .cargoTotalCustomChargeableWeight,
      cargo_total_estimate_chargeable_weight: this
        .cargoTotalEstimateChargeableWeight,
      is_use_new_calculation: this.isNewCalculation,
      cargo_divider_dimension: this.dimensionDivider,
      calculate_type: this.calculateType,
      is_minimum_volume_per_piece: this.configIsMinimumVolumePerPiece,
      min_volume_per_piece: this.configMinimumVOlumePerPiece,
      is_cargo_dimension_on: this.rebookingId
        ? this.cargo_type !== "plane"
          ? false
          : this.isCargoDimensionOn
        : this.cargo_type !== "plane"
        ? false
        : this.is_cargo_plane_manual
        ? false
        : !flags.feature_hide_dimension_koli.isEnabled(),
      is_valid_awb_manual: this.isValidAwbManual,
      current_chargeable_weight: this.currentChargeableWeight
    };

    if (this.is_cargo_plane_manual !== null) {
      data = {
        ...data,
        is_cargo_plane_manual: this.is_cargo_plane_manual
      };
    }
    if (this.ngen_booking.flight_plan_for_e_cargo.length > 0) {
      data = {
        ...data,
        ngen_booking: this.ngen_booking,
        cargo_over_cutoff_limit: this.cargo_over_cutoff_limit,
        cargo_rtc_turn_auto: this.cargo_rtc_turn_auto
      };
    }
    if (this.isUseSabre) {
      data = {
        ...data,
        sequential_flight: this.sequential_flight,
        total_flight: this.total_flight
      };
    }
    const IS_PLANE_ONLY = flags.feature_dimension_plane_only.isEnabled();
    const isCargoPlane = this.cargo_type === "plane";
    if (IS_PLANE_ONLY && isCargoPlane) {
      data = {
        ...data,
        dimensions: this.dimensions
      };
    } else {
      if (!IS_PLANE_ONLY) {
        data = {
          dimensions: this.dimensions,
          ...data
        };
      }
    }
    return JSON.stringify(data);
  }
}

export class AddBagOrStt {
  bag_no?: string;
  stt_no?: string;
  constructor(bag_no?: string, stt_no?: string) {
    this.bag_no = bag_no;
    this.stt_no = stt_no;
  }
}

export class FlightPlanForECargo {
  daily_flights_no: string;
  is_root_station: boolean;
  flight_no: string;
  flight_date: string;
  flight_origin: string;
  flight_destination: string;
  flight_dep_datetime: string;
  flight_arr_datetime: string;
  flight_date_time: string;
  flight_threshold_time?: number;
  constructor(
    daily_flights_no: string,
    is_root_station: boolean,
    flight_no: string,
    flight_date: string,
    flight_origin: string,
    flight_destination: string,
    flight_dep_datetime: string,
    flight_arr_datetime: string,
    flight_date_time: string,
    flight_threshold_time?: number
  ) {
    this.daily_flights_no = daily_flights_no;
    this.is_root_station = is_root_station;
    this.flight_no = flight_no;
    this.flight_date = flight_date;
    this.flight_origin = flight_origin;
    this.flight_destination = flight_destination;
    this.flight_dep_datetime = flight_dep_datetime;
    this.flight_arr_datetime = flight_arr_datetime;
    this.flight_date_time = flight_date_time;
    this.flight_threshold_time = flight_threshold_time;
  }
}

export class DimensionPieces {
  length = 0;
  width = 0;
  height = 0;
  pieces = 0;
  grossWeight? = 0;
  volumeWeight? = 0;
  sttOrBag? = "";

  constructor(fields?: Partial<DimensionPieces>) {
    Object.assign(this, fields);
  }
}

export class CargoListRequest {
  page = 1;
  limit = 10;
  search = "";
  cargoType = "";
  cargoTypes = "";
  originCity = "";
  destinationCity = "";
  startDate = "";
  endDate = "";
  airportCode = "";
  partnerId = 0;
  status = "";
  hubIds = "";
  isTotalData = true;
  destinationAirport = "";
  type = "";
  constructor(fields?: Partial<CargoListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class CargoRecomendationsListRequest {
  originCode = "";
  destinationCode = "";
  flightDay = "";
  comodity = "";
  totalWeight = "";
  totalVolume = "";

  constructor(fields?: Partial<CargoRecomendationsListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class UpdateRetryCargoRequest
  implements UpdateRetryCargoRequestInterface {
  action: string;

  constructor(action: string) {
    this.action = action;
  }

  public toJSON(): string {
    return JSON.stringify({
      action: this.action
    });
  }
}

export class SearchFlightRequest implements SearchFlightRequest {
  departureDate?: string;
  originCityCode?: string;
  originAirportCode?: string;
  destinationAirportCode?: string;
  actualTotalGrossWeight?: number;
  actualTotalVolumeWeight?: number;
  thresholdTime?: number;
  commodityGroupCode?: string;
  constructor(
    departureDate?: string,
    originCityCode?: string,
    originAirportCode?: string,
    destinationAirportCode?: string,
    actualTotalGrossWeight?: number,
    actualTotalVolumeWeight?: number,
    thresholdTime?: number,
    commodityGroupCode?: string
  ) {
    this.departureDate = departureDate;
    this.originCityCode = originCityCode;
    this.originAirportCode = originAirportCode;
    this.destinationAirportCode = destinationAirportCode;
    this.actualTotalGrossWeight = actualTotalGrossWeight;
    this.actualTotalVolumeWeight = actualTotalVolumeWeight;
    this.thresholdTime = thresholdTime;
    this.commodityGroupCode = commodityGroupCode;
  }

  toJSON(): string {
    return JSON.stringify({
      departure_date: this.departureDate,
      origin_city_code: this.originCityCode,
      origin_airport_code: this.originAirportCode,
      destination_airport_code: this.destinationAirportCode,
      actual_total_cargo_grossweight: this.actualTotalGrossWeight,
      actual_total_cargo_volumeweight: this.actualTotalVolumeWeight,
      threshold_time: this.thresholdTime,
      commodity_group_code: this.commodityGroupCode
    });
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class CheckAvailableRequest {
  idRow = 0;
  actualTotalCargoGrossweight = 0;
  actualTotalCargoVolumeweight = 0;
  office = "";
  participantId = "";
  cargoProductTypeCode = "";
  itineraries: SearchFlight[] = [];

  constructor(fields?: Partial<CheckAvailableRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCase(this));
  }
}

export class AwbValidationApiRequest implements AwbValidationRequestInterface {
  awbNumber = "";
  originCityCode = "";
  destinationCityCode = "";
  constructor(fields?: Partial<AwbValidationApiRequest>) {
    Object.assign(this, fields);
  }
  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class AirportRouteTypeApiRequest {
  originCityCode = "";
  destinationCityCode = "";
  constructor(fields?: Partial<AirportRouteTypeApiRequest>) {
    Object.assign(this, fields);
  }
  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class CalculateVolumeRequest {
  totalPieces = 0;
  length = 0;
  width = 0;
  divider = 0;
  height = 0;
  minVolumePerPiece = 0;
  isMinimumVolumePerPiece = true;
  volumeWeightReweigh = 0;
  chargeableWeightReweigh = 0;
  currentGrossWeight = 0;
  cargoType = "";
  totalStt = 0;
  maxDisputeWeight = 0;
  currentChargeableWeight = 0;

  constructor(fields?: Partial<CalculateVolumeRequest>) {
    Object.assign(this, fields);
    this.totalPieces = Number(this.totalPieces || 0);
    this.currentGrossWeight =
      typeof this.currentGrossWeight === "string"
        ? Number((this.currentGrossWeight as string).replace(",", "."))
        : this.currentGrossWeight;
    this.divider = getConfigDimensionDivider(this.cargoType);
  }
}

export class CalculateVolumeApiRequest {
  calculateType = "";
  calculateRequest = new CalculateVolumeRequest();
  signal?: AbortSignal;

  constructor(fields?: Partial<CalculateVolumeApiRequest>) {
    Object.assign(this, fields);
  }
  toJSON(): string {
    return JSON.stringify(
      ConvertObjectCamelToSnakeCaseV2({
        ...this,
        calculateRequest: new CalculateVolumeRequest(this.calculateRequest),
        signal: undefined
      })
    );
  }
}

export class CargoMinimumWeightSummaryApiRequest {
  startDate = "";
  endDate = "";
  hubIds = "";
  cargoType = "plane";

  constructor(fields?: Partial<CargoMinimumWeightSummaryApiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}

export class CargoSummaryInProcessRequest {
  originCity = "";
  destinationCity = "";
  destinationAirport = "";
  startDate = "";
  endDate = "";
  hubId = "";
  hubIds = "";

  constructor(fields?: Partial<CargoSummaryInProcessRequest>) {
    Object.assign(this, fields);

    if (!fields?.hubIds) {
      this.hubIds = getHubData()?.hubId || "";
    }
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}

export class DownloadCargoListApiRequest {
  startDate = "";
  endDate = "";
  hubIds = "";
  destinationCities = "";
  createdBy: number[] = [];
  cargoTypes = "";

  constructor(fields?: Partial<DownloadCargoListApiRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class FailedUnreadRequest {
  hubId = 0;
  action = "";
  destinationAirport = "";
  constructor(fields?: Partial<FailedUnreadRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}
